var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { nanoid } from 'nanoid';
import { observable, makeObservable } from 'mobx';
import { memoize } from '../../../utils/mobx/decorators/memoize';
import { WordingCleaner } from '../Cleaner/WordingCleaner';
import { InputComparer } from '../Comparer/InputComparer';
import { WordingHear } from './modules/WordingHear';
import { HearComparer } from '../Comparer/HearComparer';
import { WordingEvaluator } from './modules/WordingEvaluator';
import { WordingInfo } from './modules/WordingInfo';
import { runtime } from '../../../classes/runtime/Runtime';
export class Wording {
    parent;
    type = 'wording';
    wordingString = 'Begriff';
    constructor({ wordingString, parent }) {
        makeObservable(this);
        this.wordingString = wordingString;
        this.parent = parent;
    }
    get id() {
        return nanoid(6);
    }
    get wordingInfo() {
        return new WordingInfo(this);
    }
    get wordingEdit() {
        return new runtime.solidPackages.Edit.classes.WordingEdit(this);
    }
    get wordingCleaner() {
        return new WordingCleaner(this);
    }
    get wordingHear() {
        return new WordingHear(this);
    }
    get inputComparer() {
        return new InputComparer(this);
    }
    get hearComparer() {
        return new HearComparer(this);
    }
    get wordingEvaluator() {
        return new WordingEvaluator(this);
    }
    get wordTask() {
        return this.parent;
    }
    get question() {
        return this.wordTask.question;
    }
    get ownIndex() {
        return this.wordTask.wordings.indexOf(this);
    }
    get isPrimaryWording() {
        return this.ownIndex === 0;
    }
}
__decorate([
    observable
], Wording.prototype, "wordingString", void 0);
__decorate([
    memoize
], Wording.prototype, "id", null);
__decorate([
    memoize
], Wording.prototype, "wordingInfo", null);
__decorate([
    memoize
], Wording.prototype, "wordingEdit", null);
__decorate([
    memoize
], Wording.prototype, "wordingCleaner", null);
__decorate([
    memoize
], Wording.prototype, "wordingHear", null);
__decorate([
    memoize
], Wording.prototype, "inputComparer", null);
__decorate([
    memoize
], Wording.prototype, "hearComparer", null);
__decorate([
    memoize
], Wording.prototype, "wordingEvaluator", null);
